import { render, staticRenderFns } from "./EndGamePopup.vue?vue&type=template&id=14198fa7&"
import script from "./EndGamePopup.vue?vue&type=script&lang=js&"
export * from "./EndGamePopup.vue?vue&type=script&lang=js&"
import style0 from "./EndGamePopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VLayout,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14198fa7')) {
      api.createRecord('14198fa7', component.options)
    } else {
      api.reload('14198fa7', component.options)
    }
    module.hot.accept("./EndGamePopup.vue?vue&type=template&id=14198fa7&", function () {
      api.rerender('14198fa7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Popups/EndGamePopup.vue"
export default component.exports